import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { NewdanhmucsanphamAction } from 'src/actions/newdanhmucsanpham.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getNewdanhmucsanphamStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

import { isGrantPermission } from 'src/utils/utils';

const NewdanhmucsanphamLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedNewdanhmucsanphamIds, setSelectedNewdanhmucsanphamIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.newdanhmucsanpham);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(NewdanhmucsanphamAction.updateFilter(payload));
    dispatch(NewdanhmucsanphamAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedNewdanhmucsanphamIds;

    if (event.target.checked) {
      newSelectedNewdanhmucsanphamIds = items.map((newdanhmucsanpham) => newdanhmucsanpham.id);
    } else {
      newSelectedNewdanhmucsanphamIds = [];
    }

    setSelectedNewdanhmucsanphamIds(newSelectedNewdanhmucsanphamIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedNewdanhmucsanphamIds.indexOf(id);
    let newSelectedNewdanhmucsanphamIds = [];

    if (selectedIndex === -1) {
      newSelectedNewdanhmucsanphamIds = newSelectedNewdanhmucsanphamIds.concat(selectedNewdanhmucsanphamIds, id);
    } else if (selectedIndex === 0) {
      newSelectedNewdanhmucsanphamIds = newSelectedNewdanhmucsanphamIds.concat(selectedNewdanhmucsanphamIds.slice(1));
    } else if (selectedIndex === selectedNewdanhmucsanphamIds.length - 1) {
      newSelectedNewdanhmucsanphamIds = newSelectedNewdanhmucsanphamIds.concat(selectedNewdanhmucsanphamIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedNewdanhmucsanphamIds = newSelectedNewdanhmucsanphamIds.concat(
        selectedNewdanhmucsanphamIds.slice(0, selectedIndex),
        selectedNewdanhmucsanphamIds.slice(selectedIndex + 1)
      );
    }

    setSelectedNewdanhmucsanphamIds(newSelectedNewdanhmucsanphamIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, newdanhmucsanpham) => {
    setSelected(newdanhmucsanpham);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(NewdanhmucsanphamAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(NewdanhmucsanphamAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: '500px', width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Mã
                </TableCell>
                <TableCell>
                  Tên
                </TableCell>
                <TableCell>
                  Loại sản phẩm
                </TableCell>
                <TableCell>
                  Đơn vị nhập
                </TableCell>
                {isGrantPermission(permissions, ["newdanhmucsanpham.gianhap"]) && <TableCell>
                  Giá nhập
                </TableCell>}
                {isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi1"]) && <TableCell>
                  {(isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi2"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi3"])) ? 'Giá NCC 1' : 'Giá thực nhập'}
                </TableCell>}
                {isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi2"]) && <TableCell>
                  {(isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi1"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi3"])) ? 'Giá NCC 2' : 'Giá thực nhập'}
                </TableCell>}
                {isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi3"]) && <TableCell>
                  {(isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi1"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi2"])) ? 'Giá NCC 3' : 'Giá thực nhập'}
                </TableCell>}
                {isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat1"]) && <TableCell>
                  {(isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat2"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat3"])) ? 'Giá xuất sỉ' : 'Giá xuất'}
                </TableCell>}
                {isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat2"]) && <TableCell>
                  {(isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat1"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat3"])) ? 'Giá xuất CTV' : 'Giá xuất'}
                </TableCell>}
                {isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat3"]) && <TableCell>
                  {(isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat1"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat2"])) ? 'Giá xuất KH lẻ' : 'Giá xuất'}
                </TableCell>}
                <TableCell>
                  Thời điểm tạo
                </TableCell>
                {(role.priority < 4) && <TableCell>
                  Chức năng
                </TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((newdanhmucsanpham, index) => (
                newdanhmucsanpham ? <TableRow
                  hover
                  key={newdanhmucsanpham.id}
                  selected={selectedNewdanhmucsanphamIds.indexOf(newdanhmucsanpham.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucsanpham.ma}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucsanpham.ten}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucsanpham.loai_san_pham == 'xe' && "Xe"}
                      {newdanhmucsanpham.loai_san_pham == 'sac' && "Sạc"}
                      {newdanhmucsanpham.loai_san_pham == 'guong' && "Gương"}
                      {newdanhmucsanpham.loai_san_pham == 'tham' && "Thảm"}
                      {newdanhmucsanpham.loai_san_pham == 'ao_mua' && "Áo mưa"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {typeof newdanhmucsanpham.newdanhmucnhacungcap_ref !== 'undefined' && newdanhmucsanpham.newdanhmucnhacungcap_ref ? (newdanhmucsanpham.newdanhmucnhacungcap_ref.ma + ' - ' + newdanhmucsanpham.newdanhmucnhacungcap_ref.ten) : ''}
                    </Typography>
                  </TableCell>
                  {isGrantPermission(permissions, ["newdanhmucsanpham.gianhap"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(newdanhmucsanpham.gia_nhap).format('0,0[.]0')}₫
                    </span>
                  </TableCell>}
                  {isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi1"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(newdanhmucsanpham.gia_thuc_nhap_si_1).format('0,0[.]0')}₫<br></br>
                      (Chiết khấu: {numeral(newdanhmucsanpham.chiet_khau_1).format('0,0[.]0')}%)
                    </span>
                  </TableCell>}
                  {isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi2"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(newdanhmucsanpham.gia_thuc_nhap_si_2).format('0,0[.]0')}₫<br></br>
                      (Chiết khấu: {numeral(newdanhmucsanpham.chiet_khau_2).format('0,0[.]0')}%)
                    </span>
                  </TableCell>}
                  {isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi3"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(newdanhmucsanpham.gia_thuc_nhap_si_3).format('0,0[.]0')}₫<br></br>
                      (Chiết khấu: {numeral(newdanhmucsanpham.chiet_khau_3).format('0,0[.]0')}%)
                    </span>
                  </TableCell>}
                  {isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat1"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(newdanhmucsanpham.giaxuat1).format('0,0[.]0')}₫
                    </span>
                  </TableCell>}
                  {isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat2"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(newdanhmucsanpham.giaxuat2).format('0,0[.]0')}₫
                    </span>
                  </TableCell>}
                  {isGrantPermission(permissions, ["newdanhmucsanpham.giaxuat3"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(newdanhmucsanpham.giaxuat3).format('0,0[.]0')}₫
                    </span>
                  </TableCell>}
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {moment(newdanhmucsanpham.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                    </Typography>
                  </TableCell>
                  {(role.priority < 4) && <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(newdanhmucsanpham.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, newdanhmucsanpham)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>}
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default NewdanhmucsanphamLookupDetail;
